// extracted by mini-css-extract-plugin
export default {"wrapper":"WorkspaceLayout_wrapper__X2NVS","container":"WorkspaceLayout_container__iZ-EY"};